/* eslint-disable no-use-before-define */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

export default function FreeSolo() {
  return (
    <div style={{ width: 300, background: "transparent", margin: 0, padding: 0 }}>
      <style>{`
        .search-symptom-input .MuiOutlinedInput-root {
          background: linear-gradient(90deg, #dce4eb, #cfd1d7ff);
          border-radius: 4px;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .search-symptom-input .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
          border-color: #fb741a !important;
        }
        .search-symptom-input .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
          border-color: #fb741a !important;
        }
        .search-symptom-input .MuiInputLabel-outlined {
          color: #002D55 !important;
        }
        .search-symptom-input .MuiInputLabel-outlined.Mui-focused {
          color: #002D55 !important;
        }
      `}</style>
      <Autocomplete
        freeSolo
        id="free-solo-2-demo"
        disableClearable
        margin="dense"
        options={top100Films.map((option) => option.title)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Search symptom"
            margin="dense"
            variant="outlined"
            className="search-symptom-input"
            style={{ background: 'linear-gradient(90deg, #dce4eb, #cfd1d7ff)', borderRadius: 4, width: "100%" }}
            InputProps={{ ...params.InputProps, type: 'search' }}
          />
        )}
      />
    </div>
  );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const top100Films = [
  { title: 'Migraine'},
  { title: 'Migraine with aura'},
  { title: 'Migraine without aura'},
  { title: 'Tension-type headache'},
  { title: 'Cervicogenic headache'},
  { title: 'Medication-overuse headache'},
  { title: "Temporomandibular Joint Pain"},
  { title: 'Trigeminal Neuralgia'},
  { title: 'Discogenic Neck Pain'},
  { title: 'Neck Pain with Referred Arm Pain'},
  { title: 'Cluster Headache with Horner Syndrome'},
  { title: 'Cluster Headache without Horner Syndrome'},
  { title: 'Cervical Muscle Strain'},
  { title: 'Benign Paroxysmal Positionel Vertigo'},
  { title: 'Menierés Disease'},
  { title: "Ortostatic Hypotension"},
  { title: 'Underlying Cardiovascular Disease'},
  { title: 'Heart Disease'},
  { title: 'Non-specific neck pain'},
  { title: 'Acute Nonspecific Neck Pain with Mobility Deficits'},
  { title: 'Recurrent Nonspecific Neck Pain with Mobility Deficits'},
  { title: 'Secondary Subacromial Impingement'},
  { title: 'Frozen Shoulder'},
  { title: "Shoulder Arthritis"},
  { title: 'Biceps Tendon Rupture'},
  { title: 'Biceps Tendinopathy'},
  { title: 'Subscapularis Tendinopathy'},
  { title: 'Shoulder Bursitis'},
  { title: 'Supraspinatus/Infraspinatus Tendinopathy'},
  { title: 'Supraspinatus/infraspinatus Tendon Rupture (Partial)'},
  { title: 'Supraspinatus/infraspinatus Tendon Rupture (Full)'},
  { title: 'Subscapularis Tendon Rupture (Partial)'},
  { title: 'Subscapularis Tendon Rupture (Full)'},
  { title: 'Bankart Lesion'},
  { title: 'Non-traumatic shoulder instability, Also referred to as AMBRI'},
  { title: 'Anterior Shoulder Instability with signs of SLAP tear'},
  { title: 'Anterior Instability from repetitive overuse'},
  { title: 'Posterior Instability'},
  { title: 'Multidirectional Shoulder Instability'},
  { title: 'Anterior Shoulder Dislocation'},
  { title: 'Posterior Shoulder Dislocation'},
  { title: 'Acromioclavicular Joint Disease'},
  { title: 'Acromioclavicular Joint Separation'},
  { title: 'Clavicle Fracture'},
  { title: 'Proximal Humeral Fracture'},
  { title: 'Neck pain'},
];
